import type Phaser from 'phaser';

export type HeroFrameRect = { x: number; y: number; width: number; height: number };

export const HERO_FRAME_WIDTH = 84;
export const HERO_FRAME_HEIGHT = 280;
export const HERO_IDLE_FRAME = 'hero_2';
export const HERO_WALK_FRAME_RECTS: HeroFrameRect[] = Array.from({ length: 5 }, (_value, index) => ({
  x: index * HERO_FRAME_WIDTH,
  y: 0,
  width: HERO_FRAME_WIDTH,
  height: HERO_FRAME_HEIGHT,
}));

export function addHeroFramesToTexture(scene: Phaser.Scene, textureKey: string) {
  const texture = scene.textures.get(textureKey);
  HERO_WALK_FRAME_RECTS.forEach((rect, index) => {
    const frameName = `hero_${index}`;
    if (!texture.has(frameName)) {
      texture.add(frameName, 0, rect.x, rect.y, rect.width, rect.height);
    }
  });
}
